
// Vue
import { Component, Vue, Prop } from "vue-property-decorator";

// Components
import EventFilter from './EventFilter.vue';
import vSelect from "vue-select";

// Types
import EventSearchModel from "@/types/eventSearch/EventSearchModel";
import { Tag } from '@/types';

// Services
import api from '@/services/api.service';

@Component({
    components: {
        "event-filter": EventFilter,
        "v-select": vSelect,
    }
})
export default class FindWithTagFilter extends Vue {
    @Prop({ default: null, type: Object, required: true }) value: EventSearchModel;

    private tags: Tag[] = [];

    private selectDeselectAll: boolean = false;

    /**
     * @summary life cycle hook
     * - gets event tags.
     */
    private async mounted(): Promise<void> {
       this.tags = await api.eventTags();
    }

    /**
     * @summary computed property which gets all selected tags by id.
     */
	public get searchTags() {
		if (!this.tags) {
			return [];
		}

        return this.tags.filter(t => this.value.tags.includes(t.tagId));
	}

    /**
     * @summary setter to set tags
     */
	public set searchTags(value) {
        this.value.tags = value.map(x => x.tagId);
	}

    /**
     * @summary Method to set all and unselect all tags.
     */
    private selectDeselectTags() {
        this.selectDeselectAll = !this.selectDeselectAll;
        if (this.selectDeselectAll) {
            this.value.tags = this.tags.map(x => x.tagId);
        } else {
            this.value.tags = [];
        }
    }
}
